import { PartnerPlatform } from '../PartnerPlatform/PartnerPlatform';
import { Pagination, paginationToParams } from '../Pagination';

export interface ProductMatchingFilter {
  partnerPlatform: PartnerPlatform;
  identifier: string;
  pagination: Pagination;
}

export const getDefaultProductMatchingFilter = (
  partnerPlatform: PartnerPlatform,
): ProductMatchingFilter => ({
  partnerPlatform,
  identifier: '',
  pagination: {
    page: 0,
    pageSize: 15,
  },
});

export const productMatchingFilterToParams = (
  productMatchingFilter: ProductMatchingFilter,
) => ({
  'partner-platform': productMatchingFilter.partnerPlatform,
  identifier: productMatchingFilter.identifier,
  ...paginationToParams(productMatchingFilter.pagination),
});
